import cn from 'classnames'
import { FC, PropsWithChildren } from 'react'

import styles from './Pill.module.scss'

interface IPillProps extends PropsWithChildren {
  color: 'green' | 'blue' | 'gray'
  strikethrough?: boolean
}

export const Pill: FC<IPillProps> = ({ color, strikethrough, children }) => {
  return (
    <span className={cn(styles.pill, styles[color], { [styles.strikethrough]: strikethrough })}>
      {children}
    </span>
  )
}
